module.exports = __webpack_public_path__ + "img/cancel.7a45d0a5.svg";